var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.177,
    height: 26.265,
    viewBox: "0 0 33.177 26.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.999 -7.29)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.588,23.413a.47.47,0,0,1-.2-.047L2.272,15.779a.474.474,0,0,1,0-.858L18.386,7.335a.474.474,0,0,1,.4,0L34.9,14.921a.474.474,0,0,1,0,.858L18.79,23.365a.47.47,0,0,1-.2.047Zm-15-8.061,15,7.062,15-7.062-15-7.062Z",
    transform: "translate(0)",
    fill: "#0080ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.388,39.349A21.613,21.613,0,0,1,13.465,36.2a.474.474,0,0,1-.237-.41v-6.73a.474.474,0,1,1,.948,0v6.455a19.547,19.547,0,0,0,20.422,0V29.159a.474.474,0,0,1,.948,0v6.628a.474.474,0,0,1-.237.41A21.6,21.6,0,0,1,24.388,39.349Z",
    transform: "translate(-5.907 -11.201)",
    fill: "#0080ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.041,35.884a.474.474,0,0,1-.474-.474V26.332a.474.474,0,1,1,.948,0V35.41A.474.474,0,0,1,65.041,35.884Z",
    transform: "translate(-32.914 -9.768)",
    fill: "#0080ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.278,49.137a2.063,2.063,0,1,1,2.063-2.063A2.063,2.063,0,0,1,63.278,49.137Zm0-3.175a1.115,1.115,0,1,0,1.115,1.115,1.115,1.115,0,0,0-1.115-1.115Z",
    transform: "translate(-31.15 -19.844)",
    fill: "#0080ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.022,56.424a4.966,4.966,0,0,1-2.124-.511.474.474,0,0,1-.264-.514l.772-4.237a.474.474,0,1,1,.932.17l-.7,3.866a3.424,3.424,0,0,0,2.672.013L63.6,51.332a.474.474,0,1,1,.933-.17L65.3,55.4a.474.474,0,0,1-.245.5,4.316,4.316,0,0,1-2.038.521Z",
    transform: "translate(-30.841 -22.869)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.ab89503c.svg";
export { ForwardRef as ReactComponent };